
export type ButtonWidgetClickEnabledCallback = (button: ButtonWidget) => boolean;

export const navEnabled: ButtonWidgetClickEnabledCallback = () => true;
export const navEnabledIfCountGreaterThanZero = (b: ButtonWidget): boolean => b.number > 0;  

export class ButtonWidget {
  clickEnabled: ButtonWidgetClickEnabledCallback;
  widgetName: string;
  rows?: number;
  cols?: number;
  showNumber: boolean;
  number: number;
  label: string;
  icon: string;
  active: boolean;
  route: string;
  queryParams?: any;
  backgroundClass: string;

  constructor(name: string, showNumber?: boolean, number?: number, icon?: string, route?: string, active?: boolean, backgroundClass: string = null, clickEnabled: ButtonWidgetClickEnabledCallback = navEnabledIfCountGreaterThanZero, queryParams?: any) {
    this.widgetName = name;
    this.rows = 1;
    this.cols = 1;
    this.showNumber = showNumber;
    this.number = number;
    this.label = name;
    this.icon = icon;
    this.route = route;
    this.active = active;
    this.backgroundClass = backgroundClass;
    this.clickEnabled = clickEnabled;
    this.queryParams = queryParams;
  }
}
